import styled from 'styled-components';
import Block from '../Block';

export const StyledBlock = styled(Block)`
  transform: translate3d(0, 0, 0);
`;

export const StyledDivider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme?.colors?.gray3};
  margin: 24px 0 24px 0;
`;
